const FormFields = {
    prePaymentForm: {
        one_to_one_meeting: ["email", "guest_emails", "agenda"],
        default: ["name"],
    }
};

export default FormFields;
